import '../sass/leadership-team.scss';

function slideToggle(element, duration = 300) {
    const isHidden = getComputedStyle(element).display === 'none';

    if (isHidden) {
        element.style.display = 'block';

        const height = element.scrollHeight;

        element.style.height = '0px';
        element.style.overflow = 'hidden';

        requestAnimationFrame(() => {
            element.style.transition = `height ${duration}ms ease`;
            element.style.height = `${height}px`;
        });

        const handler = () => {
            element.style.height = '';
            element.style.overflow = '';
            element.style.transition = '';
            element.removeEventListener('transitionend', handler);
        };

        element.addEventListener('transitionend', handler);
    } else {
        element.style.height = `${element.scrollHeight}px`;
        element.style.overflow = 'hidden';

        requestAnimationFrame(() => {
            element.style.transition = `height ${duration}ms ease`;
            element.style.height = '0px';
        });

        const handler = () => {
            element.style.display = 'none';
            element.style.height = '';
            element.style.overflow = '';
            element.style.transition = '';
            element.removeEventListener('transitionend', handler);
        };

        element.addEventListener('transitionend', handler);
    }
}

document.addEventListener('click', (e) => {
    const button = e.target.closest('.leadership-team__person-body-title-expand-button');

    if (!button) return;

    e.preventDefault();

    const bio = button
        .closest('.leadership-team__person-body-title')
        ?.nextElementSibling;

    if (!bio?.classList.contains('leadership-team__bio--other')) {
        return;
    }

    button.classList.toggle('is-active');
    button.setAttribute(
        'aria-expanded',
        button.classList.contains('is-active')
    );

    slideToggle(bio);
});